import React, { Component } from "react"

import "./gallery.scss"

class Gallery extends Component {
  state = {
    activeSlide: 0,
  }

  changeSlide(i) {
    this.setState({ activeSlide: i })
    if ( window && window.innerWidth > 900 ) {
      window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth'
      });
    }
  }

  prevSlide = () => {
    if (this.state.activeSlide === 0) {
      this.setState({ activeSlide: this.props.gallery.length - 1 })
    } else {
      this.setState({ activeSlide: this.state.activeSlide - 1 })
    }
  }

  nextSlide = () => {
    if (this.state.activeSlide === this.props.gallery.length - 1) {
      this.setState({ activeSlide: 0 })
    } else {
      this.setState({ activeSlide: this.state.activeSlide + 1 })
    }
  }

  render() {
    const { gallery } = this.props
    let { activeSlide } = this.state

    return (
      <section className="gallery">
        <div className="gallery__inner">
          <div className="gallery__inner__main">
            <div
              className="gallery__inner__main__arrow gallery__inner__main__previous-arrow"
              onClick={this.prevSlide}
              aria-hidden="true"
            />
            <img
              src={gallery[activeSlide].localFile.publicURL}
              alt={gallery[activeSlide].altText}
            />
            <div
              className="gallery__inner__main__arrow gallery__inner__main__next-arrow"
              onClick={this.nextSlide}
              aria-hidden="true"
            />
          </div>
          <div className="gallery__items">
            {gallery.map((el, i) => (
              <img
                src={el.localFile.publicURL}
                alt={el.altText}
                key={i}
                onClick={() => this.changeSlide(i)}
              />
            ))}
          </div>
        </div>
      </section>
    )
  }
}

export default Gallery
